export const config = {
  slug: '',
  title: '定位',
  type: 'geolocation',
  intro: '定位设置', // 类似鼠标移过的tooltip
  required: false,
  description: '字段描述',
  readonly: false,
  hidden: false,
  defaultValue: [],
}
